import { withStyles } from '@material-ui/core';

import FieldDescription from './component';
import styles from './styles';

export default withStyles(styles)(FieldDescription);
